import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AVAILABLE_PACKAGE_ITEM_TYPE,
  SUBSCRIPTION_PURCHASED_RESPONSE,
  TRANSACTION_HISTORY_BY_CASH_RESPONSE,
  TRANSACTION_HISTORY_BY_CREDIT_RESPONSE,
} from 'models/credits';

export interface CreditsType {
  currentBalance: number;
  packageList: AVAILABLE_PACKAGE_ITEM_TYPE[];
  idPackSelected: string;
  subsPurchased: SUBSCRIPTION_PURCHASED_RESPONSE;
  transactionHistoryByCredit: TRANSACTION_HISTORY_BY_CREDIT_RESPONSE;
  transactionHistoryByCash: TRANSACTION_HISTORY_BY_CASH_RESPONSE;
}

const initialState: CreditsType = {
  currentBalance: 0,
  packageList: [],
  idPackSelected: '',
  subsPurchased: {
    metadata: {
      page: 0,
      limit: 0,
      page_count: 0,
      total_pages: 0,
      total_count: 0,
    },
    records: [],
  },
  transactionHistoryByCredit: {
    metadata: {
      page: 0,
      limit: 0,
      page_count: 0,
      total_pages: 0,
      total_count: 0,
    },
    data: [],
  },
  transactionHistoryByCash: {
    metadata: {
      page: 0,
      limit: 0,
      page_count: 0,
      total_pages: 0,
      total_count: 0,
    },
    data: [],
  },
};

const creditSlice = createSlice({
  name: 'credits',
  initialState,
  reducers: {
    setDataBalanceCredit(state: CreditsType, action: PayloadAction<number>) {
      state.currentBalance = action.payload;
    },
    setPackageList(
      state: CreditsType,
      action: PayloadAction<AVAILABLE_PACKAGE_ITEM_TYPE[]>,
    ) {
      state.packageList = action.payload;
    },
    setSelectedPackId(state: CreditsType, action: PayloadAction<string>) {
      state.idPackSelected = action.payload;
    },
    updateSubscriptionPurchased(
      state: CreditsType,
      action: PayloadAction<SUBSCRIPTION_PURCHASED_RESPONSE>,
    ) {
      if (action.payload.metadata.page <= 1) {
        state.subsPurchased = action.payload;
      } else {
        state.subsPurchased = {
          ...state.subsPurchased,
          ...action.payload,
          records: state.subsPurchased.records.concat(action.payload.records),
        };
      }
    },
    updateDataTransactionHistoryByCredit(
      state: CreditsType,
      action: PayloadAction<TRANSACTION_HISTORY_BY_CREDIT_RESPONSE>,
    ) {
      if (action.payload.metadata.offset <= 0) {
        state.transactionHistoryByCredit = action.payload;
      } else {
        state.transactionHistoryByCredit = {
          ...state.transactionHistoryByCredit,
          ...action.payload,
          data: state.transactionHistoryByCredit.data.concat(
            action.payload.data,
          ),
        };
      }
    },
    updateDataTransactionHistoryByCash(
      state: CreditsType,
      action: PayloadAction<TRANSACTION_HISTORY_BY_CASH_RESPONSE>,
    ) {
      if (action.payload.metadata.offset <= 0) {
        state.transactionHistoryByCash = action.payload;
      } else {
        state.transactionHistoryByCash = {
          ...state.transactionHistoryByCash,
          ...action.payload,
          data: state.transactionHistoryByCash.data.concat(action.payload.data),
        };
      }
    },
  },
});

export const {
  setDataBalanceCredit,
  setPackageList,
  setSelectedPackId,
  updateSubscriptionPurchased,
  updateDataTransactionHistoryByCredit,
  updateDataTransactionHistoryByCash,
} = creditSlice.actions;

export default creditSlice.reducer;
